// src/modules/panelGlobal/services/panelGlobalService.js
import axios from "../../../config/axiosConfig";

export const listPanelGlobal = (params) => axios.get("/api/panel-global", { params });

export const getPanelGlobalDetalle = (codServicioCliente, plataforma) =>
  axios.get(`/api/panel-global/${codServicioCliente}`, { params: plataforma ? { plataforma } : {} });

export const getPanelGlobalVehiculos = (codServicioCliente, params) =>
  axios.get(`/api/panel-global/${codServicioCliente}/vehiculos`, { params });

export const postSincronizarWebTrsRastreo = () =>
  axios.post("/api/panel-global/sincronizar-web-trsrastreo");

export const postSincronizarWialonLeasecontrol = () =>
  axios.post("/api/panel-global/sincronizar-wialon-leasecontrol");

export const getPanelGlobalObservaciones = (codServicioCliente) =>
  axios.get(`/api/panel-global/${codServicioCliente}/observaciones`);

export const postPanelGlobalObservacion = (codServicioCliente, body) =>
  axios.post(`/api/panel-global/${codServicioCliente}/observaciones`, body);

export const getReporteEquiposSinFacturar = (meses = 3, plataforma = "wialon") =>
  axios.get("/api/panel-global/reporte-equipos-sin-facturar", { params: { meses, plataforma } });
